import { FaroCard } from "@components/common/faro-card/faro-card";
import { ProjectCardBottom } from "@components/common/project-card/project-card-bottom";
import { CardMiddle } from "@components/common/project-card/project-card-middle";
import { ProjectCardTop } from "@components/common/project-card/project-card-top";
import styles from "@components/table/projects/projects-table.module.css";
import { BaseCompanyIdProps } from "@custom-types/base-types";
import { BaseProjectProps } from "@custom-types/project-types";
import { generateProjectDetailsRoute } from "@router/router-helper";
import { isProjectProcessingSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { getTrackProjectDateProps } from "@utils/project-utils";
import { ProjectEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { Link } from "react-router-dom";

interface Props
  extends BaseCompanyIdProps,
    BaseProjectProps {
  /** current number of projects displayed */
  numberOfProjects: number;
}

/**
 * A card that summarizes the project info
 */
export function ProjectCard({
  companyId,
  project,
  numberOfProjects,
}: Props): JSX.Element {
  const { trackEvent } = useTrackEvent();
  const isProjectProcessing = useAppSelector(
    isProjectProcessingSelector(project.id)
  );

  /** Tracks card click event in amplitude */
  function onProjectCardClick(): void {
    trackEvent({
      name: ProjectEvents.openProjectDetails,
      props: {
        projectId: project.id,
        numberOfProjects,
        ...getTrackProjectDateProps(project),
        viewMode: "cards",
      },
    });
  }

  return (
    <Link
      to={
        !isProjectProcessing
          ? generateProjectDetailsRoute(companyId, project.id)
          : "#"
      }
      onClick={() => !isProjectProcessing && onProjectCardClick()}
      className={styles["removed-underline-tile"]}
    >
      <FaroCard isLoading={isProjectProcessing} onClick={() => {}}>
        {/* Top section of the card: Shows the project thumbnail image */}
        <ProjectCardTop project={project} />

        {/* Middle section of the card: Shows the project details like name and last update */}
        <CardMiddle project={project} />

        {/* Bottom section of the card: Shows the access level and the project actions */}
        <ProjectCardBottom project={project} />
      </FaroCard>
    </Link>
  );
}
